import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/app/ui/assets/svg/logo-genesis.svg'
import _imports_1 from '@/app/ui/assets/svg/login-approval/logo-approval.svg'
import _imports_2 from '@/app/ui/assets/svg/login-approval/login-rejected.png'


const _hoisted_1 = { class: "bg-gray-lp-100 w-screen h-screen" }
const _hoisted_2 = {
  id: "login-approval",
  class: "mx-auto flex flex-col items-center justify-center gap-6",
  style: {"width":"532px","padding-top":"17.5vh"}
}
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  style: {"width":"184.5px"},
  alt: "logo genesis"
}, null, -1)
const _hoisted_4 = {
  key: 0,
  src: _imports_1,
  style: {"width":"120px"},
  alt: "illustration login approval"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_2,
  style: {"width":"120px"},
  alt: "illustration login rejected"
}
const _hoisted_6 = {
  key: 2,
  class: "flex flex-col gap-4 justify-center items-center"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "font-semibold text-2xl text-black-lp-100 text-center" }, "Menunggu konfirmasi perangkat baru", -1)
const _hoisted_8 = { class: "flex flex-col items-center text-center" }
const _hoisted_9 = {
  class: "font-bold text-black-lp-100 text-base",
  style: {"margin-bottom":"7px"}
}
const _hoisted_10 = { class: "text-sm text-gray-lp-800" }
const _hoisted_11 = { class: "flex flex-col items-center justify-center p-2 gap-2 border border-gray-lp-1400 rounded-lg text-black-lp-100" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "text-xs" }, "Kode verifikasi:", -1)
const _hoisted_13 = { class: "text-2xl font-semibold" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "text-xs text-gray-lp-800 text-center" }, [
  /*#__PURE__*/_createTextVNode(" Permintaan login dari perangkat baru telah terkirim."),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" Cocokkan kode verifikasi untuk memberikan akses. ")
], -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Cek kembali ")
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 3,
  class: "flex flex-col justify-center items-center gap-8"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "font-semibold text-2xl text-black-lp-100 text-center" }, "Login ditolak", -1)
const _hoisted_19 = { class: "text-xl text-black-lp-300 text-center" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Perangkat Anda tidak disetujui oleh user master. Mohon hubungi manager Anda di nomor ")
const _hoisted_21 = { class: "font-semibold" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" untuk informasi lebih lanjut. ")
const _hoisted_23 = {
  key: 4,
  class: "flex flex-col justify-center items-center gap-8"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("span", { class: "font-semibold text-2xl text-black-lp-100 text-center" }, "Login ditolak", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "text-xl text-black-lp-300 text-center" }, " Akun Anda hanya dapat login di Genesis Mobile. ", -1)
const _hoisted_26 = {
  style: {"margin-top":"50px"},
  class: "text-sm text-black-lp-300 text-center"
}
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Butuh bantuan? Hubungi via:")
const _hoisted_28 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" WhatsApp ")
const _hoisted_30 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Email ")
const _hoisted_32 = /*#__PURE__*/_createVNode("a", {
  href: "mailto:system@thelionparcel.com",
  class: "text-red-lp-100 underline"
}, "system@thelionparcel.com", -1)
const _hoisted_33 = {
  class: "relative w-full",
  style: {"margin-top":"90px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.isPending)
        ? (_openBlock(), _createBlock("img", _hoisted_4))
        : (_openBlock(), _createBlock("img", _hoisted_5)),
      (_ctx.isPending)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _hoisted_7,
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, _toDisplayString(_ctx.username), 1),
              _createVNode("div", _hoisted_10, _toDisplayString(_ctx.userAgent), 1)
            ]),
            _createVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode("div", _hoisted_13, _toDisplayString(_ctx.pairingCode), 1)
            ]),
            _hoisted_14,
            _createVNode("button", {
              class: ["bg-white border text-sm font-semibold flex items-center justify-center gap-1 rounded", `${_ctx.countdown === 0 ? 'border-red-lp-510 text-red-lp-510' : 'border-gray-lp-600 text-gray-lp-600'}`],
              style: {"height":"45px","width":"234px"},
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.manualCheck && _ctx.manualCheck(...args))),
              disabled: _ctx.countdown !== 0
            }, [
              _hoisted_15,
              (_ctx.countdown !== 0)
                ? (_openBlock(), _createBlock("span", _hoisted_16, "(" + _toDisplayString(_ctx.countdownValue) + ")", 1))
                : _createCommentVNode("", true)
            ], 10, ["disabled"])
          ]))
        : (_ctx.isRejected)
          ? (_openBlock(), _createBlock("div", _hoisted_17, [
              _hoisted_18,
              _createVNode("span", _hoisted_19, [
                _hoisted_20,
                _createVNode("span", _hoisted_21, _toDisplayString(_ctx.approvalPhone), 1),
                _hoisted_22
              ]),
              _createVNode("button", {
                class: "bg-white border text-sm font-semibold flex items-center justify-center gap-1 rounded w-full border-red-lp-510 text-red-lp-510",
                style: {"height":"45px"},
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, " Coba lagi ")
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_23, [
              _hoisted_24,
              _hoisted_25
            ])),
      _createVNode("div", _hoisted_26, [
        _hoisted_27,
        _hoisted_28,
        _hoisted_29,
        _createVNode("a", {
          href: `https://wa.me/${_ctx.cleanPhoneNumber(_ctx.phoneNumberHD)}`,
          class: "text-red-lp-100 underline",
          target: "_blank",
          rel: "noopener noreferrer"
        }, _toDisplayString(_ctx.phoneNumberHD), 9, ["href"]),
        _hoisted_30,
        _hoisted_31,
        _hoisted_32
      ]),
      _createVNode("div", _hoisted_33, [
        _createVNode(_component_Footer)
      ])
    ])
  ]))
}